import httpRequest from "services/httpRequest";

const prefix = "/api/call-history";

export const onGetCallHistoryPage = async params => {
  const result = await httpRequest({
    url: `${prefix}`,
    method: "GET",
    params: params,
  });
  if (!result) {
    return result;
  }
  return result;
};
